var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ApiBatchRejectSpaces } from '@/infrastructure/api-functions/api-batch-reject-spaces';
let LeaveSpacesRepositoryImpl = class LeaveSpacesRepositoryImpl {
    constructor(_apiBatchRejectSpaces) {
        this._apiBatchRejectSpaces = _apiBatchRejectSpaces;
    }
    async leaveSpaces(spaceIds) {
        const request = {
            share_ids: spaceIds,
            share_type: 'SPACE',
        };
        await this._apiBatchRejectSpaces.batchRejectSpaces(request);
        return spaceIds.map(spaceId => ({ spaceId }));
    }
};
LeaveSpacesRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(ApiBatchRejectSpaces)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiBatchRejectSpaces !== "undefined" && ApiBatchRejectSpaces) === "function" ? _a : Object])
], LeaveSpacesRepositoryImpl);
export { LeaveSpacesRepositoryImpl };
